import { TimePicker, ConfigProvider } from "antd";
import dayjs from "dayjs";

const format = "HH:mm";

const CustomTimePicker = ({
  minTime = "00:00",
  maxTime = "23:59",
  onChange,
  value,
  placeholder,
  disabled = false,
}) => {
  const min = dayjs(minTime, format);
  const max = dayjs(maxTime, format);

  const disabledTime = () => {
    return {
      disabledHours: () => {
        const hours = [];
        for (let i = 0; i < 24; i++) {
          if (i < min.hour() || i > max.hour()) {
            hours.push(i);
          }
        }
        return hours;
      },
      disabledMinutes: (selectedHour) => {
        const minutes = [];
        if (selectedHour === min.hour()) {
          for (let i = 0; i < min.minute(); i++) {
            minutes.push(i);
          }
        }
        if (selectedHour === max.hour()) {
          for (let i = max.minute() + 1; i < 60; i++) {
            minutes.push(i);
          }
        }
        return minutes;
      },
    };
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#00397d", // ✅ ใช้เป็นสี focus border ของ DatePicker
        },
      }}
    >
      <TimePicker
        style={{ height: 36 }}
        onChange={(time) => onChange(time ? time.format(format) : null)}
        value={value ? dayjs(value, format) : null}
        format={format}
        disabledTime={disabledTime}
        allowClear
        placeholder={placeholder}
        disabled={disabled}
      />
    </ConfigProvider>
  );
};

export default CustomTimePicker;
